export const NoMatch = () => <h1>{'404 - Whoopsie'}</h1>;
